import {mutationTypes} from '@/core/constants'

export default {
    [mutationTypes.SET_PARAMETROS](state, parametros) {
        state.parametros = parametros
    },
    
    [mutationTypes.SET_LICITACAO](state, resultado) {
        state.licitacao = resultado
    },
    [mutationTypes.LOKI.SET_FILES_API](state, fileConfig) {
        state.loki.file = fileConfig
    },
}
